import React from 'react';
import PropTypes from 'prop-types';

const CardItem = props => {
    return <div className='card-item'><span>{props.value}</span> {props.label}</div>;
}

CardItem.propTypes = {
    value: PropTypes.string,
    label: PropTypes.string,
};

export default CardItem;
